import { render } from "./ReminderText.vue?vue&type=template&id=7ef93dee&scoped=true&ts=true"
import script from "./ReminderText.vue?vue&type=script&lang=ts"
export * from "./ReminderText.vue?vue&type=script&lang=ts"

import "./ReminderText.vue?vue&type=style&index=0&id=7ef93dee&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef93dee"]])

export default __exports__